module.exports = __webpack_public_path__ + "img/relocate.ae466ebf.svg";